import styled from "styled-components";
import { maxBreakpoints } from "../../../../../../../shared-logic/themes/toyotaTheme";

export const SpecItem = styled.div`
    display: flex;
    align-items: flex-start;
    align-self: stretch;
    justify-content: space-between;
    column-gap: var(--spacing-1);

    dt,
    dd {
        font-size: 1.3rem;
        font-weight: 400;
        line-height: 2rem;
    }

    dt {
        @media screen and (max-width: ${maxBreakpoints.sm}) {
            max-width: 60%;
        }
    }

    dd {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        column-gap: calc(var(--spacing-1) / 2);
    }
`;

export const Sup = styled.span`
    font-size: 1rem;
    line-height: 2rem;
    vertical-align: super;
`;
